var moment = require("moment-timezone"); moment.tz.add('Africa/Mogadishu|EAT|-30|0||47e5');